export default __webpack_public_path__ + "static/media/Atualizar.a91941ab.svg";